import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectList from "../components/ui/SelectList";
import { useGetTeamMembersQuery } from "../features/members/TeamMembersApi";
import { useGetProjectsQuery } from "../features/projects/ProjectsApi";
import { useAddTaskMutation } from "../features/tasks/TasksApi";

export default function AddNewTask() {
	const { data: members, isSuccess: isMmemberFetchSuccess } = useGetTeamMembersQuery();
	const { data: projects, isSuccess: isProjectFetchSuccess } = useGetProjectsQuery();
	const [ addTask, {isSuccess: isAddNewTaskSuccess} ] = useAddTaskMutation();

	const navigate = useNavigate();

	let teamMemberList = null;
	if (isMmemberFetchSuccess) {
		teamMemberList = members.map((t) => ({ id: t.id, text: t.name }));
	}

	let projectList = null;
	if (isProjectFetchSuccess) {
		projectList = projects.map((p) => ({ id: p.id, text: p.projectName }));
	}

	useEffect(() => {
		if (isAddNewTaskSuccess) {
			navigate("/");
		}
	}, [isAddNewTaskSuccess, navigate]);

	const [taskName, setTaskName] = useState("");
	const [assignTo, setAssignTo] = useState("");
	const [project, setProject] = useState("");
	const [deadline, setDeadline] = useState("");

	const handleFormSubmit = (e) => {
		e.preventDefault();

		let newTask = {
			taskName,
			teamMember: members.find(tm => tm.id == assignTo),
			project: projects.find(p => p.id == project),
			deadline
		};

		addTask(newTask);
	};

	return (
		<main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
			<h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
				Create Task for Your Team
			</h1>

			<div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
				<form onSubmit={handleFormSubmit} className="space-y-6">
					<div className="fieldContainer">
						<label htmlFor="lws-taskName">Task Name</label>
						<input
							value={taskName}
							onChange={(e) => setTaskName(e.target.value)}
							type="text"
							name="taskName"
							id="lws-taskName"
							required
							placeholder="Implement RTK Query"
						/>
					</div>

					<div className="fieldContainer">
						<label>Assign To</label>
						{teamMemberList && (
							<SelectList
								options={teamMemberList}
								value={assignTo}
								setValue={setAssignTo}
								defaultText="Select Member"
								name="teamMember"
								id="lws-teamMember"
								required
							/>
						)}
					</div>
					<div className="fieldContainer">
						<label htmlFor="lws-projectName">Project Name</label>
						{projectList && (
							<SelectList
								options={projectList}
								value={project}
								setValue={setProject}
								defaultText="Select Project"
								id="lws-projectName"
								name="projectName"
								required
							/>
						)}
					</div>

					<div className="fieldContainer">
						<label htmlFor="lws-deadline">Deadline</label>
						<input
							value={deadline}
							onChange={(e) => setDeadline(e.target.value)}
							type="date"
							name="deadline"
							id="lws-deadline"
							required
						/>
					</div>

					<div className="text-right">
						<button type="submit" className="lws-submit">
							Save
						</button>
					</div>
				</form>
			</div>
		</main>
	);
}
